<!-- 表单选择（无value） -->
<template>
    <div>
        <!--v-model="result" -->
        <van-field
                v-bind="$attrs"
                :value="showName"
                :required="required"
                readonly
                is-link
                @click="show = !show"
        />
        <van-popup v-model="show" position="bottom">
            <van-picker
                    :columns="columns"
                    show-toolbar
                    :title="$attrs.label"
                    @cancel="show = !show"
                    @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>

<script>
    export default {
        model: {
            prop: "selectPicker"
        },
        props: {
            columns: {
                type: Array
            },
            //选中的value值
            selectValue: {
                // type: Object
            },
            //返回的value值字段名称
            chooseValue:"",
            //显示的值字段名称
            showValue:"",
            required:"",
        },
        data() {
            return {
                show: false,
                result: this.selectValue,
                showName: ''
            };
        },
        methods: {
            onConfirm(value) {
                if(this.chooseValue != undefined && this.chooseValue != null){
                    this.result = value[this.chooseValue];
                }else{
                    this.result = value;
                    this.showName = value;
                }
                if(this.showValue != undefined && this.showValue != null){
                    this.showName = value[this.showValue];
                }else{
                    this.showName = value;
                }
                this.show = !this.show;
            }
        },
        watch: {
            selectValue: function(newVal) {
                this.result = newVal;
            },
            result(newVal) {
                this.$emit("input", newVal);
            }
        }
    };
</script>

<style></style>
